export const CONVERGE_META_ACTION_IDENTIFIER = "_converge";
export const UPSERT_META_ACTION_IDENTIFIER = "_upsert";
export const DEPENDENT_DELETE_META_ACTION_IDENTIFIER = "_dependent_delete";
